import React, { useEffect, useRef, useState } from "react";
import styles from "../../TransactionsSummaryCard.module.css";

import Chart from "chart.js/auto";
import zoomPlugin from "chartjs-plugin-zoom";
Chart.register(zoomPlugin);

/** Read a CSS variable from :root (with a fallback). */
export function cssVar(name, fallback) {
  try {
    const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    return v || fallback;
  } catch {
    return fallback;
  }
}

/** Low-level canvas + Chart.js instance lifecycle. */
export function ChartCanvas({ type, data, options, height = 180, onReadyChange, onInit }) {
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (chartRef.current) { chartRef.current.destroy(); chartRef.current = null; }
    try {
      chartRef.current = new Chart(canvasRef.current, { type, data, options });
      onInit?.(chartRef.current);
      onReadyChange?.(true);
    } catch {
      onReadyChange?.(false);
    }
    return () => { if (chartRef.current) { chartRef.current.destroy(); chartRef.current = null; } };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type]);

  useEffect(() => {
    if (!chartRef.current) return;
    chartRef.current.data = data;
    chartRef.current.options = options;
    chartRef.current.update("none");
  }, [data, options]);

  return (
    <div className={styles.chartCanvasWrap} style={{ height }}>
      <canvas ref={canvasRef} className={styles.chartCanvas} />
    </div>
  );
}

/** Card wrapper with a minimal toolbar and a warning fallback. */
export function ChartBox({ title, type, data, options, height = 220, rightNode = null }) {
  const instRef = useRef(null);
  const [ready, setReady] = useState(true);

  return (
    <div className={styles.chartCard}>
      <div className="d-flex align-items-center justify-content-between">
        {title ? <div className={styles.chartTitle}>{title}</div> : <span />}
        <div className="d-flex align-items-center gap-2">
          {rightNode}

          {/* <div className={styles.chartToolbar} aria-hidden={!ready}>
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={() => instRef.current?.resetZoom?.()}
              title="Reset zoom"
            >
              Reset
            </button>
            <button
              type="button"
              className="btn btn-sm btn-outline-secondary"
              onClick={() => {
                try {
                  const url = instRef.current?.toBase64Image();
                  if (!url) return;
                  const a = document.createElement("a");
                  a.href = url; a.download = `${title || "chart"}.png`;
                  a.click();
                } catch 
              }}
              title="Download PNG"
            >
              PNG
            </button>
          </div> */}
          
        </div>
      </div>

      <ChartCanvas
        type={type}
        data={data}
        options={{ ...options, maintainAspectRatio: false, responsive: true }}
        height={height}
        onInit={(inst) => { instRef.current = inst; }}
        onReadyChange={(ok) => setReady(!!ok)}
      />

      {!ready && (
        <div className={styles.chartWarning} role="status">
          Chart unavailable — try reloading the page.
        </div>
      )}
    </div>
  );
}
